import { Injectable } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationComponent } from './confirmation.component';
import { ConfirmationResponse } from './confirmationResponse.model';

@Injectable()
export class ConfirmationService {

  constructor(private modalService: NgbModal) { }

  public confirm(
      message = 'common.defaultConfirmationMessage',
      objectText?: string,
      withComment: boolean = false,
      btnOkText: string = 'common.yes',
      btnCancelText: string = 'common.no',
      warn: boolean = false,
      causes?: Array<string>,
      otherWarnMessage?: string,
      otherWarnCauses?: Array<string>,
      infoText?: string): Promise<boolean | ConfirmationResponse> {

    // comprueba que no existe un mensaje repetido
    const causesAux = new Array<string>();
    if (causes) {
      causes.forEach((cause: string) => {
        let found = false;
        causesAux.forEach((causeAux: string) => {
          if (cause === causeAux) {
            found = true;
            return;
          }
        });
        if (!found) {
          causesAux.push(cause);
        }
      });
    }

    const modalRef = this.modalService.open(ConfirmationComponent, { });
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.objectText = objectText;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.withComment = withComment;
    modalRef.componentInstance.causes = causesAux;
    modalRef.componentInstance.warn = warn;
    modalRef.componentInstance.otherWarnCauses = otherWarnCauses;
    modalRef.componentInstance.otherWarnMessage = otherWarnMessage;
    modalRef.componentInstance.infoText = infoText;

    const returnValue: Promise<boolean | ConfirmationResponse> = modalRef.result;
    return returnValue;

  }

}
